import React from "react";
import { Section } from "@/types/common";
import { SectionRenderer } from "./SectionRenderer";

export const ReverseColumnLayout = ({ data, hideBrandLogo }: { data: Section, hideBrandLogo?: boolean }) => {
  if (!data.sections || data.sections.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto w-full xl:px-0 sm:px-6 lg:px-8 px-4" data-template={data.template}>
      <div className="flex lg:flex-row flex-col gap-8 w-full relative">
        <div className="lg:w-[30%] w-full">
          <div className="space-y-6">
          {/* {JSON.stringify(data.sections[0].template)} */}
          {/* {data.sections.length} */}
            {data.sections && data.sections.length >=1 && data.sections[0] && <SectionRenderer sectionsData={[data.sections[0]]} hideBrandLogo={hideBrandLogo} />}
          </div>
        </div>
        <div className={`lg:w-[70%] w-full ${data.template}`}>
          <div className="space-y-6 w-full">
            {/* {JSON.stringify(data.sections[1])} */}

            {data.sections && data.sections.length >=2 && data.sections[1] && <SectionRenderer sectionsData={[data.sections[1]]} hideBrandLogo={hideBrandLogo} />}
            {/* {data.sections[1] && (
              // data.sections[1].sections ? (
                Array.isArray(data.sections[1].sections) && data.sections[1].sections.length > 0 ? (
                data.sections[1].sections.map((section, index) => (
                  <SectionRenderer 
                    key={index}
                    sectionsData={[section]} 
                    showLeftBorder={section.template === "current_section"}
                  />
                ))
              ) : (
                <SectionRenderer sectionsData={[data.sections[1]]} />
              )
            )} */}
          </div>
        </div>
      </div>
    </section>
  );
}; 